export const LanguageOptions = [
    { label: "Australian English", value: "en-AU" },
    { label: "UK English", value: "en-GB" },
    { label: "Indian English", value: "en-IN" },
    { label: "NZ English", value: "en-NZ" },
    { label: "US English", value: "en-US" },
    { label: "French", value: "fr" },
    { label: "Canadian French", value: "fr-CA" },
    { label: "Hindi", value: "hi" },
];
export const GoogleLanguageOptions = [
    { label: "English", value: "en" },
    { label: "Hindi", value: "hi" },
    { label: "Bengali", value: "bn" },
    { label: "Telugu", value: "te" },
    { label: "Tamil", value: "ta" },
    { label: "Punjabi", value: "pa" },
    { label: "Marathi", value: "mr" },
];
